import { ComponentType } from "react";
import type { StepProps } from "./hooks/usePixiWizardState";
import { CheckoutStep } from "./steps/CheckoutStep/CheckoutStep";
import { NumberOfScreensStep } from "./steps/NumberOfScreensStep/NumberOfScreensStep";
import { PaymentShippingStep } from "./steps/PaymentShippingStep/PaymentShippingStep";
import { PlanBillingStep } from "./steps/PlanBillingStep/PlanBillingStep";

// Device-or-discount deals are chosen on the Plan & Billing step, so there is
// no separate "Device or Discount" step (see GRWBKK-1542).
export const PIXI_WIZARD_STEPS = [
  "Number of Screens",
  "Plan & Deals",
  "Payment & Shipping",
  "Checkout",
];

export const STEP_COMPONENTS: ComponentType<StepProps>[] = [
  NumberOfScreensStep,
  PlanBillingStep,
  PaymentShippingStep,
  CheckoutStep,
];

/** 1-indexed position of the Plan & Billing step in PIXI_WIZARD_STEPS. */
export const PLAN_BILLING_STEP = 2;

/** 1-indexed position of the Payment & Shipping step in PIXI_WIZARD_STEPS. */
export const PAYMENT_SHIPPING_STEP = 3;
